import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import analytics from '../../helpers/analytics'
import config from 'config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './AmazonVanguardLetters.css'

@CSSModules(Styles,{allowMultiple:true})
export default class AmazonVanguardLetters extends Component {
  constructor(props) {
    super(props)

    const letterTo = 'winters@amazon.com'
    const letterSubject = 'Amazon 401(k) deforestation'
    const letterText = `
Dear Mr. Winter,

I participate in our retirement plan. I recently found out that the default Amazon.com 401(k) option offered by Vanguard has significant investments in companies with ties to deforestation in the Amazon rainforest. I care about these issues and do not want my retirement savings to support companies that are destroying the environment.

The data on the Amazon.com 401(k) can be found here:
https://investyourvalues.org/retirement-plans/amazon-com

I am proud of the steps we have taken as a company to protect the environment, but we need to push Vanguard to offer more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.

Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.

Best,
    `

    const emailHref = `mailto:${letterTo}?subject=${encodeURIComponent(letterSubject)}&body=${encodeURIComponent(letterText)}`

    this.state = {
      showAdminLetter: false,
      emailHref
    }
  }

  render() {
    const { showAdminLetter, emailHref } = this.state
    //
    return (
      <div styleName='letter-box'>
        <div styleName='letter-box-flex'>
          <div styleName='letter-box-label'>
            <h2>
              Send a message to the Amazon 401(k) plan administrator
            </h2>
            <p>
              Send a message to your 401(k) plan administrator asking them for a sustainable 401(k).
            </p>
            <p>
              <button
                styleName='show-letter-button'
                onClick={
                  () => {
                    this.setState(
                      { showAdminLetter: !showAdminLetter }
                    )
                  }
                }
              >
                Letter to plan admin<LinkIcon
                  faclass={
                    showAdminLetter ?
                      'fa-angle-double-up' :
                      'fa-angle-double-down'
                  }
                />
              </button>
            </p>
          </div>
          <div styleName='take-action-icons'>
            <div>
              <Link
                to={emailHref}
                title='Send a message to your 401(k) plan administrator'
                log={analytics.eventStaffSupport('Amazon','admin_message')}
                targetBlank
              >
                <div>
                  <p>
                    Email
                  </p>
                  <div>
                    <LinkIcon nospace faclass='fa-envelope'/>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <SlideDown>
          {
            showAdminLetter ?
              (
                <div styleName='company-letter-slidedown'>
                  <p>
                    Your retirement plan administrator has a legal responsibility to act solely in your interest as a plan participant. Most 401(k) investors are primarily concerned with generating positive returns, but <Link
                      to={config.routes.eduCenterFinRisks}
                      title='Financial risks of unsustainable investments'
                      xstrong
                    >unsustainable investments could be increasing your
                    financial risk,</Link> while also destroying the environment and fueling social inequality. If these are issues that you care about, then your plan administrator has a responsibility to make sure you have the option to invest sustainably. Below is a sample letter you can send to your 401(k) Plan Administrator at Amazon.com, Steve Winter (winters@amazon.com).
                  </p>
                  <blockquote styleName='company-letter-blockquote'>
                    <p>Dear Mr. Winter,</p>

                    <p>I participate in our retirement plan. I recently found out that the default Amazon.com 401(k) option offered by Vanguard has significant investments in companies with ties to deforestation in the Amazon rainforest. I care about these issues and do not want my retirement savings to support companies that are destroying the environment.</p>

                    <p>The data on the Amazon.com 401(k) can be found here:<br/>
                    <Link
                      to={config.routes.plans + '/amazon-com'}
                      title='Amazon.com retirement plan sustainability scorecard'
                      xstrong
                    >https://investyourvalues.org/retirement-plans/amazon-com</Link></p>

                    <p>I am proud of the steps we have taken as a company to protect the environment, but we need to push Vanguard to offer more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.</p>

                    <p>Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.</p>

                    <p>Best,<br/>
                    <b>[Your Name]<br/>
                    [Your contact information: company department, email, phone, etc.]</b></p>
                  </blockquote>
                </div>
              ) :
              null
          }
        </SlideDown>

      </div>
    )
  }
}
